import { GridFilterOperator } from '@mui/x-data-grid';
import { getStringEqualsOperator } from './stringEqualsOperator';
import { t } from 'i18next';

export const getGreaterThanOperator = (): GridFilterOperator => ({
  label: t('filterOperator.greaterThan'),
  value: 'gt',
  getApplyFilterFn: (filterItem) => (params) => {
    return Number(params.value) > Number(filterItem.value);
  },
  InputComponent: getStringEqualsOperator().InputComponent,
});
